export default __webpack_public_path__ + "static/media/f28c45b54b8ef966120889a819d12d64.jpg";